import { map } from 'lodash';
import { withProps } from 'recompose';
import { cityLinkTitles } from 'config/content';
import ContentLinks from './ContentLinks';

export const enhance = withProps(({ links, city }) => ({
	columns: 1,
	links: map(links, (uri, key) => ({
		label: `${city} ${cityLinkTitles[key]}`,
		uri,
	})),
}));

export default enhance(ContentLinks);
